export const WING_TEST_ACCOUNT = {
  username: 'wing_test',
  password: 'wing123456',
};

export const STORAGE_KEYS = {
  auth: 'wing_playground_auth',
  likedUsers: 'wing_playground_liked_users',
  conversations: 'wing_playground_conversations',
  messages: 'wing_playground_messages',
  swipedIds: 'wing_playground_swiped_ids',
};

export const LOCAL_ME = {
  id: 'wing-local-me',
  name: 'Wing Tester',
  description: '',
  gender: 'male',
  age: 28,
  type: 'user',
  pictures: [
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IlFCTDQzWVVaVE9GV0lFRFpLNTIzSkVaVTRFR1BPTCIsInciOjQwMCwiaCI6NDAwLCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6MTExNDgxMjY1ODA2MjM5MDg3NTB9',
      mediaType: 'image/jpeg',
      size: [400, 400],
    },
  ],
  profile: {
    tagItems: [],
    personal: {},
    topTags: [],
  },
  verification: {
    realPerson: {
      status: 'none',
    },
  },
};
